/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QueueMessageStatusEnum } from './queueMessageStatusEnum';


export interface InventoryQueueMessage { 
    dequeued_timestamp: Date;
    /**
     * Message id
     */
    message_id: string;
    payload: string;
    queued_timestamp: Date;
    status: QueueMessageStatusEnum;
    /**
     * Provider identifier(can be providerId, entityId or componentId)
     */
    topic_name: string;
}
export namespace InventoryQueueMessage {
}


